import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-npm-lib',
  template: `
    <p>
      npm-lib works!
    </p>
  `,
  styles: []
})
export class NpmLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
